(function ($) {
    var $el = $('[data-download]');
    if($el.length > 0) {
        $el.on('click', function(e) {
            e.preventDefault();
            var id = $(this).data('download');
            btnTrigger(id);
        });
    }
}(jQuery));

function btnTrigger(id) {
    $.ajax({
        url: '/api/chapterleader/downloadredirect?id=' + id,
        type: 'GET',
        success: (data) => {
            window.open(data, '_self');
        },
        error: () => {
            window.alert('File Download Failed');
        }
    });
}



// WEBPACK FOOTER //
// ./src/app/components/download-redirect/download-redirect.js